'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = auth;

var _immutable = require('immutable');

var _AuthenticationActionTypes = require('../actionTypes/AuthenticationActionTypes');

var initialState = new _immutable.Map({
  didDetectAuth: false,
  hasNewPortalAuth: null
});

function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _AuthenticationActionTypes.DETECT_AUTH_AUTHED:
      return state.set('didDetectAuth', true);
    case _AuthenticationActionTypes.DETECT_AUTH_UNAUTHED:
      return state.set('didDetectAuth', false);

    case _AuthenticationActionTypes.AUTHENTICATION_SUCCEEDED:
      return state.set('hasNewPortalAuth', true);
    case _AuthenticationActionTypes.AUTHENTICATION_FAILED:
      return state.set('hasNewPortalAuth', false);

    default:
      return state;
  }
}
module.exports = exports['default'];